
  
$('.SubmitButton').click(function(){ 
	
    var chassis = document.getElementById('chassis').value;
    var chassisfull2 = document.getElementById('chassis').value;
    var chassisfull = chassisfull2.replace('+', "%2B");
  
	var n = chassis.indexOf(' (');
	chassis = chassis.substring(0, n != -1 ? n : chassis.length);
  
	var n2 = chassis.indexOf(' Co');
	chassis = chassis.substring(0, n2 != -1 ? n2 : chassis.length); 
  
	var n3 = chassis.indexOf(' Salo');
	chassis = chassis.substring(0, n3 != -1 ? n3 : chassis.length);

	var n4 = chassis.indexOf(' Tour');
	chassis = chassis.substring(0, n4 != -1 ? n4 : chassis.length);  
  
	var n5 = chassis.indexOf(' Gran');
	chassis = chassis.substring(0, n5 != -1 ? n5 : chassis.length);   
  
	var n6 = chassis.indexOf(' S');
	chassis = chassis.substring(0, n6 != -1 ? n6 : chassis.length);   

	var n7 = chassis.indexOf(' Road');
	chassis = chassis.substring(0, n7 != -1 ? n7 : chassis.length);   
  
	var n8 = chassis.indexOf(' 3');
	chassis = chassis.substring(0, n8 != -1 ? n8 : chassis.length);   

	var n9 = chassis.indexOf(' 5');
	chassis = chassis.substring(0, n9 != -1 ? n9 : chassis.length);   
  
	var n10 = chassis.indexOf(' Act');
	chassis = chassis.substring(0, n10 != -1 ? n10 : chassis.length);   
  
    var n11 = chassis.indexOf(' Ha');
	chassis = chassis.substring(0, n11 != -1 ? n11 : chassis.length); 
  

	var model = document.getElementById('model').value;
    var modelfull = document.getElementById('model').value;
    var modelfull = modelfull.replace('+', "%2B");
    var series = document.getElementById('series').value;
    
  
  	var n11 = model.indexOf(' (');
	model = model.substring(0, n11 != -1 ? n11 : model.length);
  
	var make = document.getElementById('make').value;  
  
  if (make === "Volkswagen"){
    
    localStorage.setItem("reflect1", make);
    localStorage.setItem("reflect2", series);
    localStorage.setItem("reflect3", chassisfull2);
  
  
  }
  
  if (make != "Volkswagen"){
  
    localStorage.setItem("reflect1", make);
    localStorage.setItem("reflect2", model);
    localStorage.setItem("reflect3", chassisfull2);
    localStorage.setItem("reflect4", series);
    
  }
  
    if (make === "Ford"){
  		window.open("/collections/brand-ford?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}
    if (make === "Infiniti"){
  		window.open("/collections/brand-infiniti?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
} 
  
    if (make === "Lexus"){
  		window.open("/collections/brand-lexus?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}  
  
    if (make === "Land Rover"){
  		window.open("/collections/brand-land-rover?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}
    
  
    if (make === "Mini"){
  		window.open("/collections/brand-mini?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}  
  
    if (make === "Suzuki"){
  		window.open("/collections/brand-suzuki?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}
  
    if (make === "Toyota"){
  		window.open("/collections/brand-toyota?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
} 
  
    if (make === "Porsche"){
  		window.open("/collections/brand-porsche?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}
  
    if (make === "Volvo"){
  		window.open("/collections/brand-volvo?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}  
  
    if (make === "Volkswagen"){
  		window.open("/collections/brand-volkswagen?lat1="+make+"&lat2="+series+"&lat3="+chassisfull+"","_self")
}
  

  
var addaudi = "?lat1="+make+"&lat2="+model+"&lat3="+chassisfull+""
var addbmw = "?lat1="+make+"&lat2="+model+"&lat3="+chassisfull+""
var addmerc = "?lat1="+make+"&lat2="+model+""

if (model === "S1" && chassis === "8X"){window.open("/collections/audi-8x-s1"+addaudi,"_self")} 
if (model === "S3" && chassis === "8V"){window.open("/collections/audi-8v-s3"+addaudi,"_self")} 
if (model === "S3" && chassis === "8V Sedan"){window.open("/collections/audi-8v-s3-sedan"+addaudi,"_self")} 
if (model === "RS3" && chassis === "8V"){window.open("/collections/audi-8v-rs3"+addaudi,"_self")} 
if (model === "A4" && chassis === "B9 40 TFSI"){window.open("/collections/audi-b9-a4-40-tfsi"+addaudi,"_self")} 
if (model === "A4" && chassis === "B9 45 TFSI"){window.open("/collections/audi-b9-a4-45-tfsi"+addaudi,"_self")} 
if (model === "S4" && chassis === "B9 30 TFSI"){window.open("/collections/audi-b9-s4-30-tfsi"+addaudi,"_self")} 
if (model === "A5" && chassis === "B9 40 TFSI"){window.open("/collections/audi-b9-a5-40-tfsi"+addaudi,"_self")} 
if (model === "A5" && chassis === "B9 45 TFSI"){window.open("/collections/audi-b9-a5-45-tfsi"+addaudi,"_self")} 
if (model === "S5" && chassis === "B9 30 TFSI"){window.open("/collections/audi-b9-s5-30-tfsi"+addaudi,"_self")} 
if (model === "A6" && chassis === "C7 35 TFSI"){window.open("/collections/audi-c7-a6-35-tfsi"+addaudi,"_self")} 
if (model === "RS6" && chassis === "C7"){window.open("/collections/audi-c7-rs6"+addaudi,"_self")} 
    
if (model === "1M" && chassis === "E82"){	window.open("/collections/bmw-performance-parts-1m-e82-1"+addaudi,"_self")}
if (model === "M2" && chassis === "F87"){window.open("/collections/bmw-f87-m2"+addbmw,"_self")}
if (model === "M2 Competition" && chassis === "F87"){window.open("/collections/bmw-f87-m2-competition"+addbmw,"_self")}  
if (model === "M3" && chassis === "F80"){window.open("/collections/bmw-f80-m3-f82-m4"+addbmw,"_self")}
if (model === "M4" && chassis === "F82"){window.open("/collections/bmw-f80-m3-f82-m4"+addbmw,"_self")}
if (model === "M5" && chassis === "F10"){window.open("/collections/bmw-f10-m5"+addbmw,"_self")}
if (model === "M6" && chassis === "F06"){window.open("/collections/bmw-f06-f12-f13-m6"+addbmw,"_self")}
if (model === "M6" && chassis === "F12"){window.open("/collections/bmw-f06-f12-f13-m6"+addbmw,"_self")}
if (model === "M6" && chassis === "F13"){window.open("/collections/bmw-f06-f12-f13-m6"+addbmw,"_self")}
if (model === "M5" && chassis === "F90"){window.open("/collections/bmw-f90-m5"+addbmw,"_self")}
if (model === "M8" && chassis === "F91"){window.open("/collections/bmw-f91-f92-f93-m8"+addbmw,"_self")}
if (model === "M8" && chassis === "F92"){window.open("/collections/bmw-f91-f92-f93-m8"+addbmw,"_self")}
if (model === "M8" && chassis === "F93"){window.open("/collections/bmw-f91-f92-f93-m8"+addbmw,"_self")}
if (model === "X5 35ix" && chassis === "E70"){window.open("/collections/bmw-e70-x5-35i-xdrive"+addbmw,"_self")}
if (model === "X6 35ix" && chassis === "E71"){window.open("/collections/e71-x6-35i-xdrive"+addbmw,"_self")}
if (model === "X6 35i" && chassis === "F16"){window.open("/collections/bmw-f16-x6-35i-1"+addbmw,"_self")}
if (model === "X3 20ix" && chassis === "F25"){window.open("/collections/bmw-f25-x3-20i-xdrive"+addbmw,"_self")}
if (model === "X3 28ix" && chassis === "F25"){window.open("/collections/bmw-f25-x3-28i-xdrive"+addbmw,"_self")}
if (model === "X3 35ix" && chassis === "F25"){window.open("/collections/bmw-f25-x3-35i-xdrive"+addbmw,"_self")}
if (model === "X4 20ix" && chassis === "F26"){window.open("/collections/bmw-f26-x4-20i-xdrive"+addbmw,"_self")}
if (model === "X4 28ix" && chassis === "F26"){window.open("/collections/bmw-f26-x4-28i-xdrive"+addbmw,"_self")}
if (model === "X4 35ix" && chassis === "F26"){window.open("/collections/f26-x4-35i-xdrive"+addbmw,"_self")}
if (model === "X4 M40ix" && chassis === "F26"){window.open("/collections/bmw-f26-x4-m40i-xdrive"+addbmw,"_self")}
if (model === "X4 20ix" && chassis === "G02"){window.open("/collections/bmw-g02-x4-20i-xdrive-1"+addbmw,"_self")}
if (model === "X4 30ix" && chassis === "G02"){window.open("/collections/bmw-g02-x4-30i-xdrive-1"+addbmw,"_self")}
if (model === "X4 M40ix" && chassis === "G02"){window.open("/collections/bmw-g02-x4-m40i-xdrive-1"+addbmw,"_self")}
if (model === "X5 40ix" && chassis === "G05"){window.open("/collections/bmw-g05-x5-m40i"+addbmw,"_self")}
if (model === "X6 40ix" && chassis === "G06"){window.open("/collections/bmw-g06-x6-m40i"+addbmw,"_self")}
if (model === "X7 40ix" && chassis === "G07"){window.open("/collections/bmw-g07-x7-40i-xdrive"+addbmw,"_self")} 
if (model === "Z4" && chassis === "G29"){window.open("/collections/bmw-g29-z4-20i-30i"+addbmw,"_self")}   
if (model === "116i" && chassis === "F20"){window.open("/collections/bmw-f20-f21-116i"+addbmw,"_self")}
if (model === "116i" && chassis === "F21"){window.open("/collections/bmw-f20-f21-116i"+addbmw,"_self")}
if (model === "118i" && chassis === "F20"){window.open("/collections/bmw-f21-118i"+addbmw,"_self")}
if (model === "118i" && chassis === "F21"){window.open("/collections/bmw-f21-118i"+addbmw,"_self")}
if (model === "120i" && chassis === "F20"){window.open("/collections/bmw-f20-f21-120i"+addbmw,"_self")}
if (model === "120i" && chassis === "F21"){window.open("/collections/bmw-f20-f21-120i"+addbmw,"_self")}
if (model === "125i" && chassis === "F20"){window.open("/collections/bmw-f22-f22-lci-125i"+addbmw,"_self")}
if (model === "125i" && chassis === "F21"){window.open("/collections/bmw-f22-f22-lci-125i"+addbmw,"_self")}
if (model === "M135i" && chassis === "F20"){window.open("/collections/bmw-f20-f21-m135i"+addbmw,"_self")}
if (model === "M135i" && chassis === "F21"){window.open("/collections/bmw-f20-f21-m135i"+addbmw,"_self")}
if (model === "M140i" && chassis === "F20"){window.open("/collections/bmw-f20-f22-m140i"+addbmw,"_self")}
if (model === "M140i" && chassis === "F21"){window.open("/collections/bmw-f20-f22-m140i"+addbmw,"_self")}
if (model === "M135ix" && chassis === "F40"){window.open("/collections/bmw-b48e-f40-m135i-xdrive"+addbmw,"_self")}  
if (model === "220i" && chassis === "F22"){window.open("/collections/bmw-f22-lci-220i"+addbmw,"_self")}
if (model === "220i" && chassis === "F23"){window.open("/collections/bmw-f22-lci-220i"+addbmw,"_self")}
if (model === "228i" && chassis === "F22"){window.open("/collections/bmw-f22-228i-228ix"+addbmw,"_self")}
if (model === "228i" && chassis === "F23"){window.open("/collections/bmw-f22-228i-228ix"+addbmw,"_self")}
if (model === "230i" && chassis === "F22"){window.open("/collections/bmw-f22-230i"+addbmw,"_self")}
if (model === "230i" && chassis === "F23"){window.open("/collections/bmw-f22-230i"+addbmw,"_self")}
if (model === "M235i" && chassis === "F22"){window.open("/collections/bmw-f22-f23-m235i"+addbmw,"_self")}
if (model === "M235i" && chassis === "F23"){window.open("/collections/bmw-f22-f23-m235i"+addbmw,"_self")}
if (model === "M240i" && chassis === "F22"){window.open("/collections/bmw-f22-m240i"+addbmw,"_self")}
if (model === "M240i" && chassis === "F23"){window.open("/collections/bmw-f22-m240i"+addbmw,"_self")}   
if (model === "335i" && chassis === "E90"){window.open("/collections/bmw-e90-lci-335i"+addbmw,"_self")}
if (model === "335i" && chassis === "E92"){window.open("/collections/bmw-e90-lci-335i"+addbmw,"_self")}
if (model === "316i" && chassis === "F30"){window.open("/collections/bmw-f30-f31-316i"+addbmw,"_self")}
if (model === "316i" && chassis === "F31"){window.open("/collections/bmw-f30-f31-316i"+addbmw,"_self")}
if (model === "318i" && chassis === "F30"){window.open("/collections/bmw-f30-f31-318i"+addbmw,"_self")}
if (model === "318i" && chassis === "F31"){window.open("/collections/bmw-f30-f31-318i"+addbmw,"_self")}
if (model === "320i" && chassis === "F30"){window.open("/collections/bmw-f30-lci-320i"+addbmw,"_self")}
if (model === "320i" && chassis === "F31"){window.open("/collections/bmw-f30-lci-320i"+addbmw,"_self")}
if (model === "328i" && chassis === "F30"){window.open("/collections/bmw-f30-f31-328i"+addbmw,"_self")}
if (model === "328i" && chassis === "F31"){window.open("/collections/bmw-f30-f31-328i"+addbmw,"_self")}
if (model === "330i" && chassis === "F30"){window.open("/collections/bmw-f30-f31"+addbmw,"_self")}
if (model === "330i" && chassis === "F31"){window.open("/collections/bmw-f30-f31"+addbmw,"_self")}
if (model === "335i" && chassis === "F30"){window.open("/collections/bmw-f30-335i"+addbmw,"_self")}
if (model === "335i" && chassis === "F31"){window.open("/collections/bmw-f30-335i"+addbmw,"_self")}
if (model === "340i" && chassis === "F30"){window.open("/collections/bmw-f31-340i"+addbmw,"_self")}
if (model === "340i" && chassis === "F31"){window.open("/collections/bmw-f31-340i"+addbmw,"_self")}
if (model === "320i" && chassis === "G20"){window.open("/collections/bmw-g20-g21-320i"+addbmw,"_self")}
if (model === "320i" && chassis === "G21"){window.open("/collections/bmw-g20-g21-320i"+addbmw,"_self")}
if (model === "330i" && chassis === "G20"){window.open("/collections/bmw-g20-330i"+addbmw,"_self")}
if (model === "330i" && chassis === "G21"){window.open("/collections/bmw-g20-330i"+addbmw,"_self")}
if (model === "M340i" && chassis === "G20"){window.open("/collections/bmw-g20-g21-m340i"+addbmw,"_self")}
if (model === "M340i" && chassis === "G21"){window.open("/collections/bmw-g20-g21-m340i"+addbmw,"_self")}
if (model === "330e" && chassis === "G20"){window.open("/collections/bmw-g20-330e"+addbmw,"_self")}   
if (model === "420i" && chassis === "F32"){window.open("/collections/bmw-f32-420i-ix"+addbmw,"_self")}
if (model === "420i" && chassis === "F33"){window.open("/collections/bmw-f32-420i-ix"+addbmw,"_self")}
if (model === "420i" && chassis === "F36"){window.open("/collections/bmw-f32-420i-ix"+addbmw,"_self")}
if (model === "428i" && chassis === "F32"){window.open("/collections/bmw-f32-f33-f36-428i-ix"+addbmw,"_self")}
if (model === "428i" && chassis === "F33"){window.open("/collections/bmw-f32-f33-f36-428i-ix"+addbmw,"_self")}
if (model === "428i" && chassis === "F36"){window.open("/collections/bmw-f32-f33-f36-428i-ix"+addbmw,"_self")}
if (model === "430i" && chassis === "F32"){window.open("/collections/bmw-f32-f33-f36-lci-430i"+addbmw,"_self")}
if (model === "430i" && chassis === "F33"){window.open("/collections/bmw-f32-f33-f36-lci-430i"+addbmw,"_self")}
if (model === "430i" && chassis === "F36"){window.open("/collections/bmw-f32-f33-f36-lci-430i"+addbmw,"_self")}
if (model === "435i" && chassis === "F32"){window.open("/collections/bmw-f32-435i"+addbmw,"_self")}
if (model === "435i" && chassis === "F33"){window.open("/collections/bmw-f32-435i"+addbmw,"_self")}
if (model === "435i" && chassis === "F36"){window.open("/collections/bmw-f32-435i"+addbmw,"_self")}
if (model === "440i" && chassis === "F32"){window.open("/collections/bmw-f32-440i"+addbmw,"_self")}
if (model === "440i" && chassis === "F33"){window.open("/collections/bmw-f32-440i"+addbmw,"_self")}
if (model === "440i" && chassis === "F36"){window.open("/collections/bmw-f32-440i"+addbmw,"_self")}   
if (model === "520i" && chassis === "F10"){window.open("/collections/bmw-f10-520i"+addbmw,"_self")}
if (model === "520i" && chassis === "F11"){window.open("/collections/bmw-f10-520i"+addbmw,"_self")}
if (model === "528i" && chassis === "F10"){window.open("/collections/bmw-f10-528i-528ix"+addbmw,"_self")}
if (model === "528i" && chassis === "F11"){window.open("/collections/bmw-f10-528i-528ix"+addbmw,"_self")}
if (model === "535i" && chassis === "F10"){window.open("/collections/bmw-f10-535i"+addbmw,"_self")}
if (model === "535i" && chassis === "F11"){window.open("/collections/bmw-f10-535i"+addbmw,"_self")}
if (model === "520i" && chassis === "G30"){window.open("/collections/bmw-g30-g31-520i"+addbmw,"_self")}
if (model === "520i" && chassis === "G31"){window.open("/collections/bmw-g30-g31-520i"+addbmw,"_self")}
if (model === "530i" && chassis === "G30"){window.open("/collections/bmw-g30-g31-530i"+addbmw,"_self")}
if (model === "530i" && chassis === "G31"){window.open("/collections/bmw-g30-g31-530i"+addbmw,"_self")}
if (model === "540i" && chassis === "G30"){window.open("/collections/bmw-g31-540i"+addbmw,"_self")}
if (model === "540i" && chassis === "G31"){window.open("/collections/bmw-g31-540i"+addbmw,"_self")}
if (model === "M550ix" && chassis === "G30"){window.open("/collections/bmw-n63r-g30-m550i-xdrive"+addbmw,"_self")}    
if (model === "640i" && chassis === "F06"){window.open("/collections/bmw-n55-f40-640i"+addbmw,"_self")}
if (model === "640i" && chassis === "F12"){window.open("/collections/bmw-n55-f40-640i"+addbmw,"_self")}
if (model === "640i" && chassis === "F13"){window.open("/collections/bmw-n55-f40-640i"+addbmw,"_self")}
if (model === "740i" && chassis === "G11"){window.open("/collections/bmw-g11-b58"+addbmw,"_self")}
if (model === "740i" && chassis === "G12"){window.open("/collections/bmw-g11-b58"+addbmw,"_self")}
if (model === "840i" && chassis === "G14"){window.open("/collections/bmw-b58c-g14-g15-g16-840i"+addbmw,"_self")}
if (model === "840i" && chassis === "G15"){window.open("/collections/bmw-b58c-g14-g15-g16-840i"+addbmw,"_self")}
if (model === "840i" && chassis === "G16"){window.open("/collections/bmw-b58c-g14-g15-g16-840i"+addbmw,"_self")}  
  
  
if (model === "A180" && chassis === "W176"){window.open("/collections/mercedes-benz-amg-w176-a180"+addmerc,"_self")}
if (model === "A250" && chassis === "W176"){window.open("/collections/mercedes-benz-amg-w176-w177-a250"+addmerc,"_self")}
if (model === "A250" && chassis === "W177"){window.open("/collections/mercedes-benz-amg-w176-w177-a250"+addmerc,"_self")}  
if (model === "A250 4Matic" && chassis === "W176"){window.open("/collections/mercedes-benz-amg-w176-w177-a250"+addmerc,"_self")}
if (model === "A250 4Matic" && chassis === "W177"){window.open("/collections/mercedes-benz-amg-w176-w177-a250"+addmerc,"_self")}
if (model === "A35 AMG" && chassis === "W177"){window.open("/collections/mercedes-benz-amg-w177-a35-amg"+addmerc,"_self")}
if (model === "A45 AMG" && chassis === "W176"){window.open("/collections/mercedes-benz-w176-a45-amg"+addmerc,"_self")}
  
if (model === "C43 AMG" && chassis === "W205"){window.open("/collections/mercedes-benz-amg-c205-c43"+addmerc,"_self")}
if (model === "C43 AMG" && chassis === "S205"){window.open("/collections/mercedes-benz-amg-c205-c43"+addmerc,"_self")}
if (model === "C43 AMG" && chassis === "C205"){window.open("/collections/mercedes-benz-amg-c205-c43"+addmerc,"_self")}
if (model === "C63S AMG" && chassis === "W205"){window.open("/collections/mercedes-benz-w205-s205-c205-c63s-amg"+addmerc,"_self")}
if (model === "C63S AMG" && chassis === "S205"){window.open("/collections/mercedes-benz-w205-s205-c205-c63s-amg"+addmerc,"_self")}
if (model === "C63S AMG" && chassis === "C205"){window.open("/collections/mercedes-benz-w205-s205-c205-c63s-amg"+addmerc,"_self")}
if (model === "C200" && chassis === "W205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c200"+addmerc,"_self")}
if (model === "C200" && chassis === "S205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c200"+addmerc,"_self")}
if (model === "C200" && chassis === "C205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c200"+addmerc,"_self")}
if (model === "C250" && chassis === "W205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c250"+addmerc,"_self")}
if (model === "C250" && chassis === "S205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c250"+addmerc,"_self")}
if (model === "C250" && chassis === "C205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c250"+addmerc,"_self")}
if (model === "C300" && chassis === "W205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c300"+addmerc,"_self")}
if (model === "C300" && chassis === "S205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c300"+addmerc,"_self")}
if (model === "C300" && chassis === "C205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c300"+addmerc,"_self")}
if (model === "C400" && chassis === "W205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c400"+addmerc,"_self")}
if (model === "C400" && chassis === "S205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c400"+addmerc,"_self")}
if (model === "C400" && chassis === "C205"){window.open("/collections/mercedes-benz-amg-w205-s205-c205-c400"+addmerc,"_self")}
if (model === "C450" && chassis === "W205"){window.open("/collections/mercedes-benz-w205-c450"+addmerc,"_self")}
if (model === "C450" && chassis === "S205"){window.open("/collections/mercedes-benz-w205-c450"+addmerc,"_self")}  
  
if (model === "E250" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-c238-e250"+addmerc,"_self")}
if (model === "E250" && chassis === "W238"){window.open("/collections/mercedes-benz-amg-w213-c238-e250"+addmerc,"_self")}
if (model === "E300" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-c238-e300"+addmerc,"_self")}
if (model === "E300" && chassis === "W238"){window.open("/collections/mercedes-benz-amg-w213-c238-e300"+addmerc,"_self")}
if (model === "E400" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e400"+addmerc,"_self")}
if (model === "E400" && chassis === "S213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e400"+addmerc,"_self")}
if (model === "E400" && chassis === "C238"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e400"+addmerc,"_self")}
if (model === "E450" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e450"+addmerc,"_self")}
if (model === "E450" && chassis === "S213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e450"+addmerc,"_self")}
if (model === "E450" && chassis === "C238"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e450"+addmerc,"_self")}
if (model === "E43" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e43"+addmerc,"_self")}
if (model === "E43" && chassis === "S213"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e43"+addmerc,"_self")}
if (model === "E43" && chassis === "C238"){window.open("/collections/mercedes-benz-amg-w213-s213-c238-e43"+addmerc,"_self")}
if (model === "E53" && chassis === "W213"){window.open("/collections/mercedes-benz-amg-w213-s213-e53"+addmerc,"_self")}
if (model === "E53" && chassis === "S213"){window.open("/collections/mercedes-benz-amg-w213-s213-e53"+addmerc,"_self")}
if (model === "E53" && chassis === "C238"){window.open("/collections/mercedes-benz-amg-c238-e53"+addmerc,"_self")} 
  
if (model === "CLA45 AMG" && chassis === "X117"){window.open("/collections/mercedes-benz-amg-x117-c117-cla45-sb"+addmerc,"_self")}
if (model === "CLA45 AMG" && chassis === "C117"){window.open("/collections/mercedes-benz-amg-x117-c117-cla45-sb"+addmerc,"_self")}
if (model === "CLA200" && chassis === "C117"){window.open("/collections/mercedes-benz-c117-cla200"+addmerc,"_self")}
if (model === "CLA250" && chassis === "X117"){window.open("/collections/mercedes-benz-x117-c117-cla250"+addmerc,"_self")}
if (model === "CLA250" && chassis === "C117"){window.open("/collections/mercedes-benz-x117-c117-cla250"+addmerc,"_self")}
if (model === "CLA250" && chassis === "X118"){window.open("/collections/mercedes-benz-x118-c118-cla250"+addmerc,"_self")}
if (model === "CLA250" && chassis === "C118"){window.open("/collections/mercedes-benz-x118-c118-cla250"+addmerc,"_self")}  
  
if (model === "GLC43 AMG" && chassis === "X253"){window.open("/collections/mercedes-benz-x253-c253-glc43-amg"+addmerc,"_self")}
if (model === "GLC43 AMG" && chassis === "C253"){window.open("/collections/mercedes-benz-x253-c253-glc43-amg"+addmerc,"_self")}
if (model === "GLC250" && chassis === "X253"){window.open("/collections/mercedes-benz-x253-c253-glc250"+addmerc,"_self")}
if (model === "GLC250" && chassis === "C253"){window.open("/collections/mercedes-benz-x253-c253-glc250"+addmerc,"_self")}
if (model === "GLC300" && chassis === "X253"){window.open("/collections/mercedes-benz-x253-c253-glc300"+addmerc,"_self")}
if (model === "GLC300" && chassis === "C253"){window.open("/collections/mercedes-benz-x253-c253-glc300"+addmerc,"_self")} 
  
if (model === "GLE43 AMG" && chassis === "W166"){window.open("/collections/mercedes-benz-w166-c292-gle43-amg"+addmerc,"_self")}
if (model === "GLE43 AMG" && chassis === "C292"){window.open("/collections/mercedes-benz-w166-c292-gle43-amg"+addmerc,"_self")}
if (model === "GLE450" && chassis === "W166"){window.open("/collections/mercedes-benz-w166-c292-gle450"+addmerc,"_self")}
if (model === "GLE450" && chassis === "C292"){window.open("/collections/mercedes-benz-w166-c292-gle450"+addmerc,"_self")}  
  
   
});  
  


